<div class="protocol-rsst">
  <div class="protocol-rsst__header">
    <!-- Header -->
    <app-details-header
      [title]="headerTitle"
      [badgeText]="headerBadgeText"
      [patientName]="patientName()"
      [measureDate]="measureDate()"
      [measurer]="measurer()" />
  </div>

  <div class="protocol-rsst__body">
    <!-- Warning Banner (below threshold) -->
    @if (isBelowThreshold()) {
      <div class="warning-banner">
        <mat-icon class="warning-banner__icon">warning_amber</mat-icon>
        <div class="warning-banner__content">
          <span class="warning-banner__title" i18n="@@details.protocolRsst.warningTitle">基準値未満</span>
          <span class="warning-banner__desc" i18n="@@details.protocolRsst.warningDesc">30秒間の嚥下回数が3回未満です。医療機関への相談を検討してください。</span>
        </div>
      </div>
    }

    <!-- KPI Row: Score + Interval + Donut (3 columns on desktop) -->
    <div class="kpi-row kpi-row--triple">
      <!-- Score Card -->
      <div class="kpi-card">
        <span class="kpi-card__title" i18n="@@details.protocolRsst.swallowScore">嚥下スコア</span>
        <div class="kpi-card__main kpi-card__main--row">
          <div class="kpi-card__circle" [class.kpi-card__circle--danger]="isBelowThreshold()">
            <span class="kpi-card__circle-value">{{ swallowCount() }}</span>
            <span class="kpi-card__circle-unit" i18n="@@details.protocolRsst.unit.times">回</span>
          </div>
          <div class="kpi-card__info">
            <span class="kpi-card__label" i18n="@@details.protocolRsst.swallowCountPer30s">嚥下回数 / 30秒</span>
            @if (isBelowThreshold()) {
              <span class="kpi-card__badge kpi-card__badge--danger" i18n="@@details.protocolRsst.belowThreshold">基準値未満</span>
            }
          </div>
        </div>
        <span class="kpi-card__meta" i18n="@@details.protocolRsst.thresholdNote">基準値: ≥ 3回/30秒</span>
      </div>

      <!-- Mean Interval Card -->
      <div class="kpi-card">
        <span class="kpi-card__title" i18n="@@details.protocolRsst.meanInterval">平均唾液嚥下間隔</span>
        <div class="kpi-card__main">
          <div class="kpi-card__value-row">
            <span class="kpi-card__value" [class.kpi-card__value--danger]="isBelowThreshold()">{{ meanInterval() }}</span>
            <span class="kpi-card__unit" i18n="@@details.protocolRsst.unit.seconds">秒</span>
          </div>
        </div>
        <span class="kpi-card__meta" i18n="@@details.protocolRsst.meanIntervalDesc">嚥下イベント間の平均間隔</span>
      </div>

      <!-- Donut Card -->
      <div class="kpi-card">
        <span class="kpi-card__title" i18n="@@details.protocolRsst.measurementResult">測定結果</span>
        <div class="kpi-card__main">
          <app-rsst-donut
            [pieChartData]="pieChartData()"
            [pieChartColor]="pieChartColor()"
            [centerValue]="swallowCount()"
            [legendItems]="donutLegend()" />
        </div>
      </div>
    </div>

    <!-- Wave + Posture + Event Timeline Card -->
    @if (showWaveCard()) {
      <div class="timeline-card">
        <div class="timeline-card__header">
          <div class="timeline-card__header-left">
            <mat-icon class="timeline-card__icon">graphic_eq</mat-icon>
            <span class="timeline-card__title">
              <span class="timeline-card__title-main" i18n="@@details.protocolRsst.timelineTitle">波形タイムライン</span>
              <span class="timeline-card__title-detail" i18n="@@details.protocolRsst.timelineSubtitle"> — 波形・姿勢・イベント</span>
            </span>
          </div>
          <span class="timeline-card__duration">
            <span i18n="@@details.protocolRsst.recordingDuration">録音時間:</span> {{ recordData()?.data?.totalTime ?? '' }}
          </span>
        </div>

        <!-- Wave + Posture + Events in single grid for mobile reorder -->
        <div class="timeline-card__grid">
          <div class="timeline-card__wave">
            <app-measured-data-wave-card
              [frameless]="true"
              [showMiniPlayback]="true"
              [recordData]="recordData()"
              [recordtype]="recordtype()"
              [recordLoadingSuccess]="recordLoadingSuccess()"
              [waveLoadingPercent]="waveLoadingPercent()"
              [waveErrorMessage]="waveErrorMessage()"
              [selectedEvent]="selectedEvent()"
              [currentStartOffset]="currentStartOffset()"
              [playing]="playing()"
              [timelineOffsetReference]="timelineOffsetReference()"
              [zoomValue]="zoomValue()"
              (offsetToggle)="offsetToggle.emit($event)"
              (seek)="seek.emit($event)"
              (playPauseClicked)="playPauseClicked.emit()"
              (zoomMinusClicked)="zoomMinusClicked.emit()"
              (zoomResetClicked)="zoomResetClicked.emit()"
              (zoomPlusClicked)="zoomPlusClicked.emit()" />
          </div>

          <div class="timeline-card__posture">
            <app-measured-data-neck-angle-card
              [frameless]="true"
              [chartOption]="chartOption()"
              [currentChartOption]="currentChartOption()"
              [currentOrientation]="currentOrientation()"
              (chartInit)="chartInit.emit($event)"
              (currentChartInit)="currentChartInit.emit($event)" />
          </div>

          <!-- Event Table (full width) -->
          <div class="timeline-card__events">
            <app-event-table
              [events]="events()"
              (seekToEvent)="onEventSeek($event)" />
          </div>

          <!-- Data Footer (full width) -->
          <div class="timeline-card__footer">
            <app-data-footer
              [dataId]="dataId()"
              nbModel="nbModel v2.1"
              [downloadUrl]="downloadUrl()" />
          </div>
        </div>
      </div>
    }

    <!-- Reference Card -->
    <app-reference-card [searchLinks]="searchLinks()" />

    <!-- Disclaimer -->
    <app-disclaimer [message]="disclaimer" />
  </div>
</div>
